import { Directive, Input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from "@angular/forms";
import { ArrayHelper } from "../../utilities/contracts/array-helper";
import { SelectableInput } from "../inputs/selectable-input.model";

export const enabledOptionsOnlyValidator = (options: SelectableInput[]): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value == null) {
      return null;
    }

    const option = options.find(item => item.value === value);
    if (option == null) {
      return null;
    }

    return option == null || option.disabled ? { enabledoptionsonly: true } : null;
  };
};

@Directive({
  selector: "[app-enabled-options-only]",
  providers: [{ provide: NG_VALIDATORS, useExisting: EnabledOptionsOnlyValidatorDirective, multi: true }],
})
export class EnabledOptionsOnlyValidatorDirective implements Validator {
  @Input() options: SelectableInput[] = [];

  validate(control: AbstractControl): ValidationErrors | null {
    return ArrayHelper.isAvailable(this.options)
      ? enabledOptionsOnlyValidator(this.options)(control)
      : null;
  }
}
